<template>
    <div>
        <div id="layout-user" :class="layoutClass" :style="{ minHeight: layoutHeight + 'px' }">

            <sideNav v-if="layoutType != 'mobile'" :isMiniSideBar="miniSideBar" @toggleNav="toggleSideNav" :style="{ height: layoutHeight + 'px' }"></sideNav>

            <mobileNav :contentHeight="contentHeight" v-else />

            <div class="content_page_section" :style="{ height: contentHeight + 'px' }">
                <slot/>
            </div>

        </div>
    </div>
</template>

<script>
    import sideNav from "./sideNav"
    import mobileNav from "./mobileNav"

    export default {
        name: 'layoutUser',
        components: {
            sideNav,
            mobileNav
        },
        data() {
            return {
                layoutHeight: window.innerHeight,
                layoutWidth: window.innerWidth,
                openedSideNav: false,
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
        computed: {
            layoutType(){
                if(this.layoutWidth < 1024){
                    return 'mobile'
                }else if(this.layoutWidth < 1400){
                    return 'tablet'
                }else{
                    return 'desktop'
                }
            },
            miniSideBar(){
                return this.layoutType != 'desktop' ? true : this.openedSideNav
            },
            layoutClass(){
                return {
                    'mini-sidenav': this.miniSideBar,
                    "is-mobile": this.layoutType == 'mobile'
                }
            },
            contentHeight(){
                if(this.layoutType == "mobile"){
                    return this.layoutHeight - 60
                }else{
                    return this.layoutHeight
                }
            }
        },
        methods: {
            handleResize() {
                this.layoutHeight = window.innerHeight;
                this.layoutWidth = window.innerWidth;

            },
            toggleSideNav(){
                this.openedSideNav = !this.openedSideNav
                console.log("toggleNav")
            }
        }
    }
</script>

<style lang="scss">
html{
    overflow: hidden!important;
}
#layout-user{
    display: flex;
    &.is-mobile{
        flex-direction: column;
    }
    .content_page_section{
        width: 100%;
        overflow-y: scroll;
        overflow-x: hidden;
    }
}
</style>